export default "__VITE_ASSET__CsO4F7A7__"